import { useRef as m, useState as x, useCallback as b, useEffect as v } from "react";
function E({
  padding: r = [0, 0, 0, 0],
  containerRef: e
}) {
  const u = m(), [s, o] = x(1), l = b(() => {
    if (!e.current || !e.current.parentElement || !u.current)
      return;
    const t = u.current.getBBox(), i = t.x - r[3], h = t.y - r[0], n = t.width + r[3] + r[1], c = t.height + r[0] + r[2];
    e.current.setAttribute("viewBox", [i, h, n, c].join(" ")), o(Math.max(
      n / e.current.parentElement.clientWidth,
      c / e.current.parentElement.clientHeight
    ));
  }, []);
  return v(() => {
    if (!e.current || !e.current.parentElement || (u.current = e.current.children[0], !u.current))
      return;
    const t = new ResizeObserver(l);
    return t.observe(u.current), () => t.disconnect();
  }, []), { scale: s };
}
export {
  E as useSvgResizer
};
//# sourceMappingURL=index10.js.map
